export default __webpack_public_path__ + "static/media/Varun-Kaushik.9e6308a9.jpg";